export const environment = {
  production: false,
  API_URL: 'https://api-linkit.propertylink.cl/',
  API_V1: '',
  ENCRYPT: true,
};

